<template>
    <v-container class="pa-12 fill-height align-start" fluid>
        <v-row>
            <v-col>
                <v-btn small depressed outlined color="accent" :to="`/${$i18n.locale}/administrator/creative/projects`"
                ><v-icon left>mdi-arrow-left</v-icon> Back to projects</v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card outlined>
                    <div class="overline pl-4 pt-4">
                        Project description - {{ project.dateAdded ? dateFormat(project.dateAdded.localTime) : '' }}
                    </div>
                    <div class="d-flex flex-column pa-4">
                        <div class="title" v-text="project.title"></div>
                        <v-card flat color="grey lighten-4" class="my-4">
                            <v-card-text class="richtext-container" v-html="project.description"></v-card-text>
                        </v-card>
                        <div class="pb-4">
                            <v-chip
                                outlined
                                color="primary"
                                class="mr-2"
                                v-text="`Topic: ${getTopicById(project.topicId)}`"
                            ></v-chip>
                            <v-chip
                                outlined
                                color="primary"
                                class="mr-2"
                            >
                                Biding ends: {{ project.bidDeadline ? dateFormat(project.bidDeadline.localTime) : '' }}
                            </v-chip>
                            <v-chip
                                outlined
                                color="primary"
                            >
                                Voting ends: {{ project.votingDeadline ? dateFormat(project.votingDeadline.localTime) : '' }}
                            </v-chip>
                        </div>
                        <div class="">
                            <v-btn 
                                text 
                                color="secondary" 
                                target="_blank"
                                :href="`${baseImageUrl}${file.file}`"
                                v-for="(file, index) in projectFiles"
                                :key="index"
                            ><v-icon left>mdi-file-document</v-icon> {{ file.fileName }}</v-btn>
                        </div>
                    </div>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card outlined :loading="loadingBids">
                    <template v-if="bids.length > 0">
                        <v-row class="px-4">
                            <v-col>
                                <div class="overline">First name</div>
                            </v-col>
                            <v-col>
                                <div class="overline">Last name</div>
                            </v-col>
                            <v-col>
                                <div class="overline">Bid title</div>
                            </v-col>
                            <v-col>
                                <div class="overline">Date</div>
                            </v-col>
                            <v-col>
                                <div class="overline">Status</div>
                            </v-col>
                            <v-col>
                                <div class="overline">Actions</div>
                            </v-col>
                        </v-row>
                        <template v-for="(bid, index) in bids">
                            <v-divider :key="index"></v-divider>                 
                            <v-row 
                                class="px-4"
                                :key="bid.bid.id"
                            >
                                <v-col>
                                    <div class="subtitle-2" v-text="bid.user.firstName"></div>
                                </v-col>
                                <v-col>
                                    <div class="subtitle-2" v-text="bid.user.lastName"></div>
                                </v-col>
                                <v-col>
                                    <div class="subtitle-2" v-text="bid.bid.title"></div>
                                </v-col>
                                <v-col>
                                    <div class="subtitle-2" v-text="dateFormat(bid.bid.date.localTime)"></div>
                                </v-col>
                                <v-col>
                                    <template v-if="bid.bid.isPending">
                                        <v-chip small>Pending</v-chip>
                                    </template>
                                    <template v-else>
                                        <v-chip small color="primary" v-if="bid.bid.isApproved">Approved</v-chip>
                                        <v-chip small color="secondary" v-else>Rejected</v-chip>
                                    </template>
                                </v-col>
                                <v-col>
                                    <v-btn
                                        depressed
                                        small
                                        color="primary"
                                        :to="`/${$i18n.locale}/administrator/bid/review/${bid.bid.id}`"
                                    >View details</v-btn>
                                </v-col>
                            </v-row>
                        </template>
                    </template>
                    <template v-else>
                        <div class="subtitle-1 pa-4">No bids available</div>
                    </template>
                    <v-row></v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import moment from 'moment'
    import { mapGetters } from 'vuex'

    export default {
        name: 'projectBids',
        data: () => ({
            bids: [],
            project: {},
            projectFiles: [],
            projectId: null,
            topics: [],
            snackbar: {
                show: true,
                message: ''
            },
            loadingProject: true,
            loadingBids: true
        }),
        computed: {
            ...mapGetters(['user', 'baseImageUrl'])
        },
        beforeMount() {
            this.projectId = this.$route.params.id
        },
        mounted() {
            this.fetchProject()
            this.fetchBids()
            this.fetchTopics()
        },
        methods: {
            async fetchProject() {
                this.axios.get('/Project/GetProject', {
                    params: {
                        id: this.projectId,
                        languageId: 1
                    }
                })
                .then(response => {
                    this.project = response.data.project
                    this.projectFiles = response.data.projectFiles
                })
                .catch(error => {
                    this.snackbar.message = error.message
                    this.$EventBus.$emit('snackbar', this.snackbar)
                })
                this.loadingProject = false
            },
            async fetchBids() {
                await this.axios.get('/ProjectBid/GetAll', {
                    params: {
                        languageId: 1,
                        projectId: this.projectId
                    }
                })
                .then(response => {
                    this.bids = response.data
                })
                .catch(error => {
                    this.snackbar.message = error.message
                    this.$EventBus.$emit('snackbar', this.snackbar)
                })
                this.loadingBids = false
            },
            fetchTopics() {
                this.axios.get('/Topic/GetAllTopics', {
                    params: {
                        languageId: 1
                    }
                })
                .then(response => {
                    this.topics = response.data
                })
            },
            dateFormat(date) {
                return moment(date).format('MM/DD/YYYY')
            },
            getTopicById(id) {
                return this.topics.filter(topic => topic.id == id).map(topic => topic.name)
            }
        }
    }
</script>

<style lang="scss" scoped></style>